import { render, staticRenderFns } from "./WaitForModerator.vue?vue&type=template&id=7da6e39e&scoped=true&"
import script from "./WaitForModerator.vue?vue&type=script&lang=js&"
export * from "./WaitForModerator.vue?vue&type=script&lang=js&"
import style0 from "./WaitForModerator.vue?vue&type=style&index=0&id=7da6e39e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da6e39e",
  null
  
)

export default component.exports